import { Dropdown, ButtonGroup } from 'react-bootstrap';
import Styles from './CustomTemplateDropdown.module.css';

const CustomTemplateDropdown = ({ icon: Icon, items }) => {
  return (
    <Dropdown as={ButtonGroup} className="position-absolute top-0 end-0">
      <Dropdown.Toggle
        id="template-dropdown"
        className={`border-0  pb-1 ${Styles.noArrow}`}
        style={{
            backgroundColor: "transparent",
            borderRadius: "5px",
            padding: 0,
            cursor: "pointer",
          }}
      >
        <Icon size={24} color= "#303030" />
      </Dropdown.Toggle>

      <Dropdown.Menu align="end" className='p4'>
        {items.map((item, index) => (
          <Dropdown.Item key={index} onClick={item.onClick}>
            {item.label}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default CustomTemplateDropdown;

// Usage
// import { FaEllipsisV } from "react-icons/fa";
// import CustomTemplateDropdown from "./CustomTemplateDropdown";


// const items = [
//   {
//     label: "Edit",
//     onClick: () => handleEdit(item),
//   },
//   {
//     label: "Delete",
//     onClick: () => handleDelete(item.id),
//   },

//   <CustomTemplateDropdown icon={FaEllipsisV} items={items} />
